<template>
  <div>
    <h1>BALLOTPEDIA API4</h1>
    <div class="row login-container">
    <div class="container">
      <div class="col-md-offset-4 col-md-4 col-xs-12">
        <form>
          <div class="form-group">
            <input type="email" class="form-control" placeholder="Email" v-model="email">
          </div>
          <div class="form-group">
            <input type="password" class="form-control" placeholder="Password" v-model="password">
          </div>
          <button type="button" v-on:click="login" class="btn btn-default login-btn">Login</button>
          <p v-if="loginSuccessful === false" class="invalid-login">Invalid email or password.</p>
          <!-- <p class="reset-link">Forgot Password?</p> -->
        </form>
        <div v-if="loading" class="fa-3x">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
      </div>
      </div>
  </div>
  </div>
</template>


<script>

import moment from 'moment';

export default {
  name: 'Login',
  data() {
    return {
      email: null,
      password: null,
      loginSuccessful: null,
      loading: false
    }
  },
  methods: {
    login: async function() {
      this.loading = true;

      let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/login`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
          email: this.email,
          password: this.password
        })
      });
      
      response = await response.json();
      console.log('this is the login response')
      console.log(response)
      
      this.loginSuccessful = response.success;
      if (response.success) {
        this.saveRoles(response.data.user_role.json_agg);

        // refresh xsrf token after login
        response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/xsrf_refresh`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({})
        });

        response = await response.json();
        await this.checkSchemaVersion();
        this.loading = false;
        this.$router.push({ path: '/home' });
        return response;
      }
    },

    async checkSchemaVersion() {
      try {
        const response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            resource: `${process.env.VUE_APP_API4_DOMAIN}/schema/version`
          },
          credentials: 'include'
        });
        const data = await response.json();
        const currentVersion = String(data.message);
        const storedVersion = localStorage.getItem('schema_version');
        if (storedVersion !== currentVersion) {
          localStorage.removeItem('schema_tables');
          localStorage.setItem('schema_version', currentVersion);
        }
      } catch (e) {
        console.error('[Login] schema version check failed', e);
      }
    },

    // remove api from role names and save to local storage
    saveRoles(roles) {
      roles.forEach( (role, i) => {
        roles[i] = roles[i].replace('api_', '');
      });
      localStorage.setItem('roles', JSON.stringify(roles));
    }
  }
}

</script>

<style scoped>

.login-container, h1 {
  text-align: center;
}

form {
  margin-top: 25px;
}

.invalid-login {
  color: red;
  margin-top: 10px;
}

.login-btn {
  width: 100%;
  background-color: #3498DB;
  color: white;
  font-weight: 600;
}
.reset-link {
  color: #3498DB;
  margin-top: 10px;
  font-size: 12px;
}

</style>
